import type { IconTileProps } from '@atlaskit/icon/types';

const BOLD_APPEARANCES: IconTileProps['appearance'][] = [
	'redBold',
	'orangeBold',
	'yellowBold',
	'limeBold',
	'greenBold',
	'tealBold',
	'blueBold',
	'purpleBold',
	'magentaBold',
];

/**
 * Deterministically maps a task ID string to one of the bold IconTile appearances.
 * The same ID always returns the same appearance, but different IDs are spread
 * across the full palette.
 */
export function getAppearanceFromId(id: string): IconTileProps['appearance'] {
	let hash = 0;
	for (let i = 0; i < id.length; i++) {
		hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
	}
	return BOLD_APPEARANCES[hash % BOLD_APPEARANCES.length];
}
